import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SystemRole {
  id: string;
  name: string;
  code: string;
  description?: string;
  department_id?: string;
  permissions: {
    clients?: { create: boolean; read: boolean; update: boolean; delete: boolean; scope: string };
    cases?: { create: boolean; read: boolean; update: boolean; delete: boolean; scope: string };
    leads?: { create: boolean; read: boolean; update: boolean; delete: boolean; scope: string };
    documents?: { create: boolean; read: boolean; update: boolean; delete: boolean; scope: string };
    payments?: { create: boolean; read: boolean; update: boolean; delete: boolean; scope: string };
  };
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const useSystemRoles = () => {
  const { data: roles, isLoading, error } = useQuery({
    queryKey: ['system-roles'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('system_roles')
        .select('*')
        .eq('is_active', true)
        .order('name');

      if (error) throw error;
      return data as SystemRole[];
    },
  });

  return { roles: roles || [], isLoading, error };
};
